import { Component, Input } from '@angular/core';

export interface Slide {
  imgSrc: string;
  imgAlt: string;
  name: string;
}
@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent {
  @Input() images: Slide[] = [];

  selectedIndex = 0;
  id:any = 0;
  name: string = '';
  ngOnInit() {
    this.name = this.images[0].name;
    this.id = setInterval(() => {
      this.callMethod(this.selectedIndex); 
    }, 5000);
  }
  
  callMethod(i: number){
    if (this.selectedIndex < this.images?.length - 1) {
      this.name = this.images[this.selectedIndex + 1].name;
      this.selectedIndex = i + 1;
    } else {
      this.name = this.images[0].name;
      this.selectedIndex = 0;
    }
  }

  showPrev(i: number) {
    if (this.selectedIndex > 0) {
      this.selectedIndex = i - 1;
    }
  }

  showNext(i: number) {
    if (this.selectedIndex < this.images?.length - 1) {
      this.selectedIndex = i + 1;
    } else this.selectedIndex = 0;
  }

  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    }
  }
}
